module.exports = __webpack_public_path__ + "media/images/logo_webshop-blue_full-4aeff0557230c4ec9c26f9fd9d2ebe4a.svg";